<template>
<div class="card" v-loading.fullscreen.lock="loader">
  <div class="section-heading" align="center">UPDATE USER</div>
  <br>
    <div>
      <el-row>
        <el-col :span="3">
          <p style="font-size: 18px; font-family: times new roman">Select User</p>
        </el-col>
        <el-col :span="21">
          <el-select v-model="UpdateUserID" placeholder="Select User ID">
            <el-option
                v-for="(item, key) in UserList"
                :key="key"
                :label="item.firstName"
                :value="key">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <br>
    </div>
    <div v-if="UpdateUserID">
      <el-form ref="form" :model="form" label-width="120px" label-position="top">
        <el-row>
            <el-col :span="11">
            <el-form-item label="First Name  ">
                <el-input v-model="form.firstName"></el-input>
            </el-form-item>
            </el-col>
            <el-col :span="11" :offset="2">
            <el-form-item label="Last Name  ">
                <el-input v-model="form.lastName"></el-input>
            </el-form-item>
            </el-col>
        </el-row>
        <br>
        <el-row>
            <el-col :span="11">
            <el-form-item label="First Name  ">
                <el-input v-model="form.firstName"></el-input>
            </el-form-item>
            </el-col>
            <el-col :span="11" :offset="2">
            <el-form-item label="Last Name  ">
                <el-input v-model="form.lastName"></el-input>
            </el-form-item>
            </el-col>
        </el-row>
        <br>
        <el-row>
            <el-col :span="11">
            <el-form-item label="Mobile Number">
                <el-input v-model="form.mobile"></el-input>
            </el-form-item>
            </el-col>
            <el-col :span="11" :offset="2">
            <el-form-item label="Unidue ID">
                <el-input v-model="form.unique_id"></el-input>
            </el-form-item>
            </el-col>
        </el-row>
        <div class="row m-3 flex-end" style="margin-right:10rem;">
            <el-button class="btn-theme" @click="update('form')">Update User</el-button>
        </div>
      </el-form>
    </div>
</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'UpdateUser',
  data () {
    return {
      loader: false,
      UserList: [],
      UpdateUserID: '',
      form: {
        firstName: '',
        lastName: '',
        mobile: '',
        unique_id: ''
      },
      rules: {
        firstName: [
          { required: true, message: 'Enter First Name', trigger: 'change' }
        ],
        lastName: [
          { required: true, message: 'Enter Last Name', trigger: 'change' }
        ],
        mobile: [
          { required: true, message: 'Enter Mobile Number', trigger: 'change' }
        ],
        unique_id: [
          { required: true, message: 'Enter Unique Id', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      getUsers: 'Survey/getUserList'
    })
  },
  methods: {
    ...mapActions({
      fetchUsers: 'Survey/fetchUserList',
      updateUser: 'Survey/updateUser'
    }),
    setDetails (val) {
      console.log('type of user list', this.UserList[val])
      let details = this.UserList[val]
      this.form.firstName = details.firstName
      this.form.lastName = details.lastName
      this.form.mobile = details.mobile
      this.form.unique_id = details.uniqueId
    },
    update (form) {
      this.updateUser({
        id: this.form.unique_id,
        firstName: this.form.firstName,
        lastName: this.form.lastName,
        mobile: this.form.mobile
      })
    }
  },
  mounted () {
    this.fetchUsers()
    this.loader = true
  },
  watch: {
    getUsers (val) {
      if (val === 'Error') {
        this.$message.error('Try Again...')
      } else if (val.success === true) {
        console.log('usere list', val)
        this.UserList = val.data
      } else {
        this.$message.eror(val.message)
      }
      this.loader = false
    },
    UpdateUserID (val) {
      this.setDetails(val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/User/UpdateUser.vue